/* eslint-disable import/prefer-default-export */
import { QueryClient, UseQueryOptions, UseQueryResult, useQuery } from "@tanstack/react-query";
import { getCities } from "api/services/common";
import { GetCitiesResponseType } from "api/response";
import { GetCitiesListRequestParams } from "api/request/common.request";
import { commonQueryKeys } from "./commonQueryKeys";

/**
 * Imperative counterpart to useGetCities, for event handlers that need the list on demand.
 * Shares the cache key with the hook so both dedupe onto a single request.
 */
export function fetchCitiesQuery(
  queryClient: QueryClient,
  params: GetCitiesListRequestParams,
): Promise<GetCitiesResponseType> {
  return queryClient.fetchQuery({
    queryKey: commonQueryKeys.cities(params),
    queryFn: () => getCities({ params }).then((res) => res.data),
  });
}

export function useGetCities<T = GetCitiesResponseType>(
  params: GetCitiesListRequestParams,
  options?: UseQueryOptions<GetCitiesResponseType, unknown, T>,
): UseQueryResult<T> {
  return useQuery<GetCitiesResponseType, unknown, T>({
    queryKey: commonQueryKeys.cities(params),
    queryFn: () => getCities({ params }).then((res) => res.data),
    enabled: !!params.country,
    refetchOnMount: false,
    ...options,
  });
}
